/**
 * @generated SignedSource<<bf869010b6e8d4464ad8a1aec35cd76e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type useWidgetTeamScheduleSubscriptionIssueStatusChangedSubscription$variables = {
  teamId: string;
};
export type useWidgetTeamScheduleSubscriptionIssueStatusChangedSubscription$data = {
  readonly issueStatusChanged: {
    readonly taskExecution: {
      readonly routine: {
        readonly inProgressOccasion: {
          readonly id: string;
          readonly issueCount: number;
        } | null;
      } | null;
      readonly routineOccasion: {
        readonly id: string;
        readonly issueCount: number;
      };
    };
  } | null;
};
export type useWidgetTeamScheduleSubscriptionIssueStatusChangedSubscription = {
  response: useWidgetTeamScheduleSubscriptionIssueStatusChangedSubscription$data;
  variables: useWidgetTeamScheduleSubscriptionIssueStatusChangedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "teamIds.0",
        "variableName": "teamId"
      }
    ],
    "kind": "ListValue",
    "name": "teamIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "issueCount",
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "RoutineOccasion",
  "kind": "LinkedField",
  "name": "inProgressOccasion",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "RoutineOccasion",
  "kind": "LinkedField",
  "name": "routineOccasion",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useWidgetTeamScheduleSubscriptionIssueStatusChangedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Issue",
        "kind": "LinkedField",
        "name": "issueStatusChanged",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "taskExecution",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Routine",
                "kind": "LinkedField",
                "name": "routine",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useWidgetTeamScheduleSubscriptionIssueStatusChangedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Issue",
        "kind": "LinkedField",
        "name": "issueStatusChanged",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "taskExecution",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Routine",
                "kind": "LinkedField",
                "name": "routine",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "eaf2d1a67734b8975d7e7b391a59cc97",
    "id": null,
    "metadata": {},
    "name": "useWidgetTeamScheduleSubscriptionIssueStatusChangedSubscription",
    "operationKind": "subscription",
    "text": "subscription useWidgetTeamScheduleSubscriptionIssueStatusChangedSubscription(\n  $teamId: ID!\n) {\n  issueStatusChanged(teamIds: [$teamId]) {\n    taskExecution {\n      __typename\n      routine {\n        inProgressOccasion {\n          id\n          issueCount\n        }\n        id\n      }\n      routineOccasion {\n        id\n        issueCount\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "57fd44394ef472e92310e6ee1f767b89";

export default node;
